import React from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import { useWizard } from 'react-use-wizard'
import { CUSTOM_ROLE } from 'web/src/app/root/constants'
import { PageTitle, Button } from 'web/src/app/root/components/common'
import { LocationReviewItem } from './location-review-item'
import { useCreateUser } from '../../context/create-user-context'
import { useSelector } from 'react-redux'
import { needSkipLocationsAssign } from '../../utils'
import { getRoleName } from 'web/src/utils'

export const Review = ({ onSubmit, isSubmitted }) => {
    const { previousStep, goToStep, activeStep } = useWizard()

    const { userState, isFromLocationAssignment } = useCreateUser()
    const { locale } = useSelector(state => state.main)
    const styles = useStyles()
    const isCustomRole = !userState.role_code && userState.role

    const handleSubmit = () => {
        onSubmit()
    }
    //Mapping on allRoles because it also contains custom roles
    const allRoles = useSelector(state =>
        state.userManagement.roles
            ? state.userManagement.roles.reduce((acc, role) => {
                  acc[role.code] = getRoleName(role, locale)
                  return acc
              }, {})
            : null
    )
    const handlePrevStep = () => {
        //go two steps back if we dont need select loctions for selected role
        if (
            needSkipLocationsAssign(
                userState.role_code,
                userState.role,
                isFromLocationAssignment
            )
        ) {
            const roleSelectStep = activeStep - 2
            return goToStep(roleSelectStep)
        }
        previousStep()
    }
    return (
        <div className={styles.root}>
            <PageTitle
                position={'center'}
                title={locale.userManagement.reviewStepTitle}
            />
            <div className={styles.columnsContainer}>
                <div className={styles.col}>
                    {userState.name && (
                        <div className={styles.valueBlock}>
                            <span>{locale.common.name}:</span>
                            {userState.name}
                        </div>
                    )}
                    <div className={styles.valueBlock}>
                        <span>{locale.common.email}:</span>
                        {userState.email}
                    </div>
                    <div className={styles.valueBlock}>
                        <span>{locale.common.role}:</span>
                        {isCustomRole
                            ? locale.userManagement.roleNames[CUSTOM_ROLE]
                            : allRoles[userState.role_code]}
                    </div>
                </div>
                {userState.locations && (
                    <div className={styles.locationsRoot}>
                        <div className={styles.locationsColWrapper}>
                            <div className={styles.locationsTotal}>
                                {locale.locations.locations}:{' '}
                                {userState.locations?.length}
                            </div>
                            <div className={styles.locationsList}>
                                {userState.locations.map(l => (
                                    <LocationReviewItem
                                        locationId={l.id}
                                        key={l.id}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.buttonsBlock}>
                <Button reverted onClick={handlePrevStep}>
                    {locale.userManagement.stepBack}
                </Button>
                <Button disabled={isSubmitted} onClick={handleSubmit}>
                    {isSubmitted && (
                        <CircularProgress
                            size={24}
                            color="inherit"
                            style={{ marginRight: 8 }}
                        />
                    )}
                    {locale.userManagement.completeBtn}
                </Button>
            </div>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    locationsRoot: {
        overflow: 'auto'
    },
    locationsTotal: {
        height: 50,
        borderBottom: theme.border,
        padding: 16
    },
    locationsList: {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100vh - 500px)',
        '&& > div:not(:last-child)': {
            borderBottom: theme.border
        },
        width: 'fit-content'
    },
    locationsColWrapper: {
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        background: '#F9F9F9',
        borderRadius: 3
    },
    col: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    valueBlock: {
        display: 'flex',
        padding: 16,
        height: 50,
        background: '#F9F9F9',
        borderRadius: 3,
        marginBottom: 8,
        fontWeight: 'bold',
        '&& span': {
            flexBasis: '50px',
            marginRight: 8,
            color: '#A0A0A0'
        }
    },
    root: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        flex: 1,
        padding: '40px 94px 0'
    },
    buttonsBlock: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // marginTop: 'auto',
        marginBottom: 46,
        marginTop: 20,
        '&& > :last-child': {
            marginLeft: 16
        }
    },
    columnsContainer: {
        width: '100%',
        marginTop: 60,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridGap: 20
    }
}))
